


































































































































import { Vue, Component, Prop, Watch, Emit, Ref } from "vue-property-decorator";
import { State, Getter, Action, Mutation } from "vuex-class";
import {
  handleRefreshTokenEvent,
  event,
  cleanStatusAndTimerForLogout
} from "../../libs/utils";
import {
  toggleMerchantStatus,
  changeAutoAcceptOrder,
  changeAutoReadyOrder,
  changeReceiveMessages,
  changeMerchDecideConfirmedTime,
  changePrintingStatus
} from "@/api/php/merchant";
import { ILoginMerchant } from "../../types/interface/User/UserTypes";
import store from "../../store/index";
import { NavigationMenu } from "../../types/enum/OrderEnum";
import { merchInfo } from "../../api/net/loginApi";
@Component
export default class Home extends Vue {
  isShowDialog: boolean = false;
  @Getter("showCombinedTab") showCombinedTab!: boolean;
  @Getter("merchId") merchId!: string;
  @Mutation("handleLoginMerchant") handleLoginMerchant!: Function;
  @Mutation("handleShowCombinedTab") handleShowCombinedTab!: Function;
  @Mutation("handleAutoReadyOrders") handleAutoReadyOrders!: Function;
  @Mutation("handleReceiveMessage") handleReceiveMessage!: Function;
  @Mutation("handleIsAsapOnly") handleIsAsapOnly!: Function;
  @Mutation("handleMerchDecideConfirmedTime")
  handleMerchDecideConfirmedTime!: Function;
  @Mutation("handleIsPrintEnable") handleIsPrintEnable!: Function;

  specialMerchIds: string[] = store.state.specialMerchant;

  public get merchantStatus(): boolean {
    return !!this.loginMerchant.status;
  }

  public set merchantStatus(v: boolean) {
    if (this.merchantStatus) {
      this.$modal
        .open({
          title: "Are you sure close the store?",
          message: ""
        })
        .then((result: boolean) => {
          if (result) {
            this.changeMerchantStatus(v);
            return;
          }
          let vnode = this.$refs.merchantStatus as Element;
          vnode.hasColor = this.merchantStatus;
          vnode.lazyValue = this.merchantStatus;
        });
    } else {
      this.changeMerchantStatus(v);
    }
  }

  public get autoAcceptOrder(): boolean {
    return this.loginMerchant.autoAcceptOrder;
  }

  public set autoAcceptOrder(v: boolean) {
    this.changeAutoAcceptOrder(v);
  }

  public get combinedTab(): boolean {
    return this.showCombinedTab;
  }

  public set combinedTab(v: boolean) {
    this.handleShowCombinedTab(v);
  }

  public get loginMerchant(): ILoginMerchant {
    return this.$store.state.loginMerchant;
  }

  public get status(): number {
    return this.$store.state.loginMerchant.status || 0;
  }

  public get autoReadyOrders(): boolean {
    return this.$store.state.autoReadyOrders;
  }

  public set autoReadyOrders(v: boolean) {
    this.changeAutoReadyOrder(v);
  }

  public get receiveMessage(): boolean {
    return this.$store.state.receiveMessage;
  }

  public set receiveMessage(v: boolean) {
    this.changeReceiveMessage(v);
  }

  public get merchDecideConfirmedTime(): boolean {
    return this.$store.state.merchDecideConfirmedTime;
  }

  public set merchDecideConfirmedTime(v: boolean) {
    this.changeMerchDecideConfirmedTime(v);
  }

  public get isAsapOnly(): boolean {
    return this.$store.state.isAsapOnly;
  }

  public get printingStatus(): boolean {
    return this.$store.state.isPrintEnable;
  }

  public set printingStatus(v: boolean) {
    this.changePrintingStatus(v);
  }

  public get isShowprintingStatusSetting(): boolean {
    return !(this.$store.state.isPc || this.$store.state.openInBrowser);
  }

  public get isShowprintingStatusSettingForTest(): boolean {
    return (
      this.specialMerchIds.includes(this.merchId.toUpperCase()) &&
      (!window.location.href.includes("yamimeal.com") ||
        window.config.showDev) &&
      !(this.$store.state.openInBrowser || this.$store.state.isPc)
    );
  }

  public get isShowprintingStatusSettingForPRD(): boolean {
    return (
      this.specialMerchIds.includes(this.merchId.toUpperCase()) &&
      !(this.$store.state.openInBrowser || this.$store.state.isPc) &&
      window.location.href.includes("yamimeal.com")
    );
  }

  async changeAutoAcceptOrder(autoAcceptOrder: boolean) {
    let loginMerchant = { ...this.loginMerchant };
    loginMerchant.autoAcceptOrder = autoAcceptOrder;
    let {
      data: { code, data, msg }
    } = await changeAutoAcceptOrder();
    store.commit("handleShowLoading", false);
    if (code * 1 === 0) {
      this.handleLoginMerchant(loginMerchant);
      this.$message.show({
        text: `Success`
      });
    } else {
      this.$message.show({
        text: msg
      });
    }
  }

  async changeMerchantStatus(status: boolean) {
    let loginMerchant = { ...this.loginMerchant };
    loginMerchant.status = status ? 1 : 0;
    let {
      data: { code, data, msg }
    } = await toggleMerchantStatus();
    store.commit("handleShowLoading", false);
    if (code * 1 === 0) {
      this.handleLoginMerchant(loginMerchant);
      this.$message.show({
        text: `Success`
      });
    } else {
      this.$message.show({
        text: msg
      });
    }
  }

  async changeAutoReadyOrder(status: boolean) {
    const {
      data: { code, data, msg }
    } = await changeAutoReadyOrder();
    store.commit("handleShowLoading", false);
    if (code * 1 === 0) {
      this.handleAutoReadyOrders(status);
      this.$message.show({
        text: `Success`
      });
    } else {
      this.$message.show({
        text: msg
      });
    }
  }

  async changeReceiveMessage(status: boolean) {
    const {
      data: { code, data, msg }
    } = await changeReceiveMessages();
    store.commit("handleShowLoading", false);
    if (code * 1 === 0) {
      this.handleReceiveMessage(status);
      this.$message.show({
        text: `Success`
      });
    } else {
      this.$message.show({
        text: msg
      });
    }
  }

  async changeMerchDecideConfirmedTime(status: boolean) {
    const {
      data: { code, data, msg }
    } = await changeMerchDecideConfirmedTime();
    store.commit("handleShowLoading", false);
    if (code * 1 === 0) {
      this.handleMerchDecideConfirmedTime(status);
      this.$message.show({
        text: `Success`
      });
    } else {
      this.$message.show({
        text: msg
      });
    }
  }

  async changePrintingStatus(status: boolean) {
    const {
      data: { code, data, msg }
    } = await changePrintingStatus();
    store.commit("handleShowLoading", false);
    if (code * 1 === 0) {
      this.handleIsPrintEnable(status);
      this.$message.show({
        text: `Success`
      });
    } else {
      this.$message.show({
        text: msg
      });
    }
  }

  async getMerchantInfo() {
    try {
      const {
        result: {
          autoMarkOrderToReady,
          willingToReceiveNotification,
          isAsapOnly,
          merchDecideConfirmedTime
        }
      } = await merchInfo(this.merchId);
      this.handleAutoReadyOrders(autoMarkOrderToReady);
      this.handleReceiveMessage(willingToReceiveNotification);
      this.handleIsAsapOnly(isAsapOnly);
      this.handleMerchDecideConfirmedTime(merchDecideConfirmedTime);
    } catch (e) {
    } finally {
      store.commit("handleShowLoading", false);
    }
  }

  toHistoryOrder() {
    this.$router.push({
      name: "History"
    });
  }

  @Mutation("handleOptions")
  handleOptions!: Function;

  @Mutation("handleClearIntervals")
  handleClearIntervals!: Function;

  toYamimealSupport() {
    event("toSupport", "");
  }

  toPrinterSetting() {
    event("toPrinterSetting", "");
  }

  signOut() {
    cleanStatusAndTimerForLogout();
  }

  mounted() {
    this.getMerchantInfo();
  }
}
